import { useEffect } from 'react';

/**
 * Component that redirects to an external URL.
 * Uses window.location.replace for a clean redirect without adding to browser history.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};

export default ExternalRedirect;
